import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EmptySeriesPlaceholder = () => {
  const { t } = useTranslation(['badges']);

  return (
    <Box textAlign="center" py={3}>
      <Typography variant="subtitle1">
        {t('badges:management.series.noData')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('badges:management.series.createFirstSeries')}
      </Typography>
    </Box>
  );
};

export default EmptySeriesPlaceholder;
